import styles from "./styles.module.css";

export function LogoutPopover({ onLogoutClick, onProfileSettingClick }: any) {
  return (
    <div className={styles.popoverContainer}>
      <button type="button" onClick={onProfileSettingClick}>
        Profile Setting
      </button>
      <button type="button" onClick={onLogoutClick}>
        Logout
      </button>
    </div>
  );
}
